import { Roles } from '../@shared/role.constants';

function homepagePath(user: any) {
  if (user.role === Roles.superadmin || user.role === Roles.tsemployee) return '/super-admin';
  else return '/agent';
}

export { homepagePath };
